import React, { Component, Fragment } from 'react';
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import BasicInfo from "./BasicInfo";
import ExtendInfo from "./ExtendInfo";
import Media from "./Media";
import Model from "./../../../../../models/RoomType"
import isEqual from "lodash/isEqual";
import { UPLOAD_DIRECTORY, DETAIL_ACTIONS, PATHS, FEATURE_FLAGS } from '../../../../../constants/Define';
import { cloneDeep } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';
export default class RoomTypeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
            action: this.props.match.params.id ? DETAIL_ACTIONS.UPDATE : DETAIL_ACTIONS.CREATE,
            roomType: new Model({ hotelId: this.props.match.params.hotel_id, isActive: true }),
            validation: {},
            isUploading: false,
            isReady: !this.props.match.params.id //Render when create
        };
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        const roomType = this.state.roomType || {};
        roomType[params.name] = params.value
        this.setState({ roomType, isSubmit: false });
    };

    onChangeField = (fieldName, value) => {
        const roomType = this.state.roomType;
        roomType[fieldName] = value;
        this.setState({ roomType });
    };

    onChangeRoomFeatures = (e) => {
        let params = Func.getValueForm(e);
        const roomType = this.state.roomType || {}
        if (params && params.name && params.value) {
            roomType.setRoomFeatures(params.name, params.value)
            this.setState({ roomType });
        }
    };

    uploadFileMultiple = (file) => {
        let data = file.target.files;
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        this.setState({
            isUploading: true
        });
        Object.keys(data).map((i) => {
            if (imageValidation.includes(data[i].type)) {
                this.props.onUploadFile({ file: data[i], directory: UPLOAD_DIRECTORY.ROOM_TYPES, isFile: 2 })
            }
        })
    };

    removeImage = (src) => {
        if (!src) return;
        const roomType = this.state.roomType;
        roomType.removeMedia(src)
        this.setState({ roomType });
    }

    componentDidMount() {
        const { match } = this.props;
        match.params.id && this.props.getRoomType(match.params.id);
        match.params.id && this.props.getListAmenities();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.uploadState !== prevProps.uploadState && this.props.uploadState.file) {
            const roomType = this.state.roomType;
            roomType.addMedia(this.props.uploadState.file.data.fileUrl)
            this.setState({ roomType, isUploading: false });
        }
    }

    onClickBack = () => {
        const { match } = this.props;
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
                const path = Func.getPathWithParams(PATHS.ROOM_TYPE.LIST.path, { hotel_id: match.params.hotel_id })
                this.props.history.push(path);
            }
        }
    }

    onShowTranslate = (language) => {
        const { roomType } = this.state;
        roomType.setTranslate(language.code);
        roomType.setData();
        this.setState({ roomType, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const roomType = cloneDeep(this.state.roomType);
        const action = DETAIL_ACTIONS[roomType.id ? 'UPDATE' : 'CREATE'];
        roomType.setTranslate(undefined, true);
        roomType.setData();
        this.setState({ roomType, action });
    }

    onSaveTranslate = () => {
        const { roomType } = this.state;
        const translateFunction = roomType.translate.id ? this.props.updateRoomTypeTranslate : this.props.createRoomTypeTranslate;
        translateFunction(roomType, roomType.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { roomType } = this.state;
        roomType.setTranslate(language.code);
        this.props.deleteRoomTypeTranslate(roomType, { id: roomType.id });
    }

    onSubmit = (e) => {
        const { roomType } = this.state;
        e.preventDefault();
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else {
                this.setState({
                    isSubmit: true
                });
                if (this.state.action === DETAIL_ACTIONS.CREATE) {
                    const payload = {
                        "roomtype": {
                            "code": roomType.code,
                            "name": roomType.name,
                            "description": roomType.description,
                            "shortDescription": roomType.shortDescription,
                            "area": roomType.area,
                            "maxOccupancy": roomType.maxOccupancy,
                            "maxAdult": roomType.maxAdult,
                            "maxChild": roomType.maxChild,
                            "hotelId": roomType.hotelId,
                            "media": [],
                            "hardblock": roomType.hardblock,
                            "numberOfRoom": roomType.numberOfRoom ? roomType.numberOfRoom : 1,
                            "isActive": false,
                        }
                    }
                    this.props.createRoomType(payload)
                } else {
                    this.props.saveRoomType({ roomType: this.state.roomType, props: this.props });
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.roomTypeState.roomType && !isEqual(nextProps.roomTypeState.roomType, this.props.roomTypeState.roomType) && !nextProps.roomTypeState.isFetching) {
            this.setState({
                roomType: nextProps.roomTypeState.roomType,
                isReady: true,
                loading: false,
                isSubmit: false
            });
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.roomType.name`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.roomType.code`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.roomType, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    render() {
        const { t, match, uploadState, amenityState } = this.props;
        const { action, roomType, isReady, isSubmit, validation } = this.state;
        const { isFetchingMultiple, isFetching } = uploadState;
        const { amenities } = amenityState;
        return (
            <Fragment>{isReady &&
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'room-types'}
                        titleHeader={Func.capitalizeFirstLetter((`${t(action === DETAIL_ACTIONS.CREATE ? 'action.create' : 'action.update')} ${t('item.roomType.title')}`).toLowerCase())}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={roomType.translations}
                                current={roomType.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChange({ name: 'languageCode', value: language.code })}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <div className="row">
                        <div className="col-md-6">
                            <BasicInfo action={action} validation={validation} loading={isSubmit} onChange={this.onChange} roomType={roomType} />
                        </div>
                        <div className="col-md-6">
                            <ExtendInfo action={action} validation={validation} loading={isSubmit} onChangeRoomFeatures={this.onChangeRoomFeatures} onChange={this.onChange} roomType={roomType} amenities={amenities} onChangeAmenity={this.onChangeField} />
                        </div>
                    </div>
                    <HMS.FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={false}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        activeComponent={false}
                        onChangeActive={this.onChange}
                        titleActiveComponent={t(`item.banner.active`)}
                        submitButtonRight={true}
                        statusActiveName={`isEnabled`}
                        statusActive={false}
                    >
                        <HMS.FormWrapperItem>
                            <div className="col-md-12">
                                <Media loading={isFetchingMultiple || isFetching}
                                    removeImage={this.removeImage}
                                    isUploading={isFetchingMultiple || isFetching}
                                    uploadFileMultiple={this.uploadFileMultiple}
                                    onUploadFile={this.props.onUploadFile} roomType={roomType}
                                    onChange={this.onChange} />
                            </div>
                            {(action === DETAIL_ACTIONS.UPDATE) && (
                                <AutoTranslate
                                    className="wrapper-full room-type"
                                    languageCode={roomType?.languageCode || 'vi-VN'}
                                    onChange={this.onChangeField}
                                    targetLanguage={roomType?.targetLanguage}
                                />
                            )}
                        </HMS.FormWrapperItem>
                    </HMS.FormActionComponent>
                </HMS.PageListComponent>
            }
            </Fragment>
        );
    }
}
